import { render, staticRenderFns } from "./ReportesMarketing.vue?vue&type=template&id=0d3d8070"
import script from "./ReportesMarketing.vue?vue&type=script&lang=js"
export * from "./ReportesMarketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports